import { z } from "zod";

export const TrafficZod = z.coerce.number().int().min(0).max(99999);
export const CustomTrafficZod = z.union([TrafficZod, z.literal("")]);
export type CustomTrafficType = z.infer<typeof CustomTrafficZod>;
